<template>
  <div class="news-page">
    <van-tabs
      v-model="activeTabIndex"
      class="news-tabs"
      :border="false"
      swipeable
      color="#337ECC"
      title-active-color="#303133"
      title-inactive-color="#909399"
      line-width="28px"
      line-height="3px"
    >
      <van-tab
        v-for="(t, i) in tabList"
        :key="i"
        :title="t.name"
      />
    </van-tabs>

    <div class="news-body">
      <div v-if="pageLoading" class="state-tip">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </div>
      <template v-else>
        <div v-if="displayList.length" class="news-cards">
          <div
            v-for="item in displayList"
            :key="item.id"
            class="news-card"
            role="button"
            tabindex="0"
            @click="goDetail(item)"
            @keyup.enter="goDetail(item)"
          >
            <div class="news-card__text">
              <div class="news-card__title">{{ item.title || '—' }}</div>
              <div class="news-card__time">{{ formatRelative(item.publishDate) }}</div>
            </div>
            <div class="news-card__thumb-wrap" v-if="posterUrl(item)">
              <img
                class="news-card__thumb"
                :src="posterUrl(item)"
                alt=""
              >
            </div>
          </div>
        </div>
        <div v-else class="state-tip">
          <van-empty description="暂无内容" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabs, Tab, Loading, Empty } from 'vant'
Vue.use(Tabs).use(Tab).use(Loading).use(Empty)
import { getBMUnionMatch, getCrmNewsList } from '@/api/match'
import { QNImageUtil } from '@/utils'
import wx from 'weixin-js-sdk'
import { AppType } from '@/constants/appType'

function formatPublishRelative(dateStr) {
  if (!dateStr) return ''
  const ts = new Date(dateStr).getTime()
  if (Number.isNaN(ts)) return ''
  let diff = Date.now() - ts
  if (diff < 0) diff = 0
  const minutes = Math.floor(diff / 60000)
  if (minutes < 1) return '刚刚'
  if (minutes < 60) return `${minutes}分钟前`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}小时前`
  const days = Math.floor(hours / 24)
  if (days < 30) return `${days}天前`
  const months = Math.floor(days / 30)
  if (months < 12) return `${months}个月前`
  return `${Math.floor(months / 12)}年前`
}

export default {
  data() {
    return {
      unionMatchId: '',
      accountId: '',
      pageLoading: true,
      tabList: [
        { name: '全部', type: null },
        { name: '新闻', type: 0 },
        { name: '公告', type: 1 },
      ],
      activeTabIndex: 0,
      allNews: []
    }
  },
  computed: {
    displayList() {
      const t = this.tabList[this.activeTabIndex]
      if (!t || t.type === null || t.type === '' || t.type === undefined) {
        return this.allNews
      }
      const want = Number(t.type)
      return this.allNews.filter(item => Number(item.type) === want)
    }
  },
  mounted() {
    this.unionMatchId = this.$route.params.unionMatchId
    this.bootstrap()
  },
  methods: {
    formatRelative: formatPublishRelative,
    posterUrl(item) {
      const p = item && item.poster
      if (!p || !String(p).trim()) return ''
      return QNImageUtil.imageView(String(p), 120, 120)
    },
    bootstrap() {
      if (!this.unionMatchId) {
        this.pageLoading = false
        return
      }
      const preview = this.$route.query.preview || 0
      getBMUnionMatch({ unionMatchId: this.unionMatchId, preview })
        .then(res => {
          if (res === false) {
            this.accountId = ''
            return ''
          }
          const data = (res && res.data) || {}
          const match = data.match || {}
          this.accountId = match.accountId != null ? String(match.accountId) : ''
          const title = match.chineseName
          document.title = title ? `${title}-新闻公告` : '新闻公告'
          return this.accountId
        })
        .then(accountId => {
          if (!accountId) return Promise.resolve()
          return getCrmNewsList({
            accountId,
            unionMatchId: this.unionMatchId,
            pageNum: 1,
            pageSize: 500,
          }).then(res => this.applyNewsList(res))
        })
        .catch(() => {})
        .finally(() => {
          this.pageLoading = false
        })
    },
    applyNewsList(res) {
      if (res === false || !res || !res.data) {
        this.allNews = []
        return
      }
      const list = res.data.list
      this.allNews = Array.isArray(list) ? list : []
    },
    goDetail(item) {
      if (!item || item.id == null) return
      if (item.contentType === 2 && item.sourceUrl) {
        let url = item.sourceUrl
        if (!/^https?:\/\//i.test(url)) {
          url = `https://${url}`
        }
        if (AppType.isInWeChat() && window.__wxjs_environment === 'miniprogram') {
          wx.miniProgram.navigateTo({
            url: `/pages/webview/index?redirect=${encodeURIComponent(url)}`
          })
        } else {
          window.location.href = url
        }
        return
      }
      const path = `/account/news-detail/${item.id}`
      if (AppType.isInWeChat() && window.__wxjs_environment === 'miniprogram') {
        const baseHash =
          process.env.NODE_ENV === 'development'
            ? 'https://www.snsports.cn/match-h5-dev/index.html#'
            : 'https://www.snsports.cn/match-h5/index.html#'
        wx.miniProgram.navigateTo({
          url: `/pages/webview/index?redirect=${encodeURIComponent(baseHash + path)}`
        })
      } else {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.news-page {
  min-height: 100vh;
  background: #fff;
  box-sizing: border-box;
}

.news-body {
  padding: 0 16px 24px;
}

.state-tip {
  padding: 48px 16px 24px;
  text-align: center;
}

.news-cards {
  display: flex;
  flex-direction: column;
  padding-top: 12px;

  > * + * {
    margin-top: 12px;
  }
}

.news-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 78px;
  padding: 0 12px;
  background: #f9f9f9;
  border-radius: 3px;
  box-sizing: border-box;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &:active {
    opacity: 0.92;
  }
}

.news-card__thumb-wrap {
  flex-shrink: 0;
  margin-left: 12px;
}

.news-card__text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  overflow: hidden;
}

.news-card__title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  line-height: 21px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.news-card__time {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 16px;
  flex-shrink: 0;
}

.news-card__thumb {
  width: 60px;
  height: 60px;
  border-radius: 3px;
  object-fit: cover;
  display: block;
  background: #ebedf0;
}

.news-card__thumb--placeholder {
  background: #e4e7ed;
}
</style>

<style lang="scss">
.news-page {
  .news-tabs {
    .van-tabs__nav {
      background: #fff;
    }
    .van-tab {
      font-size: 15px;
    }
    .van-tabs__line {
      border-radius: 2px;
    }
  }
}
</style>
